import { createIntl, createIntlCache } from "react-intl";

import enMessages from "_metronic/i18n/messages/en";

// English is the only translated locale. The de/es/fr/ja/zh files that used to
// sit alongside it were untouched Metronic template stubs — 67 keys each against
// en's 1,203 — and nothing ever selected them: `setLanguage` is never dispatched
// and the `lang` state is hard-coded to "en".
const allMessages = {
  en: enMessages,
};

// Messages may contain formatting tags, e.g.
//   "NOTE: Only <strong>completed</strong> requests will be archived"
// react-intl does not treat these as HTML. Unless a tag is registered it has no
// handler, formatting fails, and the raw message is rendered with the tags
// visible as text. Registering them here fixes every message at once instead of
// each call site having to pass its own `values`.
//
// A call site can still override these by passing the tag in `values` — see
// ForgotPassword, which renders <div> with its own spacing.
//
// Adding a new tag to a message means adding it here too.
const defaultRichTextElements = {
  strong: (chunks) => <strong>{chunks}</strong>,
  b: (chunks) => <b>{chunks}</b>,
  em: (chunks) => <em>{chunks}</em>,
  i: (chunks) => <i>{chunks}</i>,
  p: (chunks) => <p>{chunks}</p>,
  div: (chunks) => <div>{chunks}</div>,
};

const cache = createIntlCache();
export const kaddimIntl = {
  currentLocale: null,
  intlInstance: null,

  set locale(loc) {
    this.currentLocale = loc;
    this.intlInstance = createIntl(
      {
        locale: loc,
        // Fall back to English rather than rendering raw message ids if an
        // unknown locale is ever set.
        messages: allMessages[loc] || allMessages.en,
        defaultRichTextElements,
      },
      cache
    );
  },
  get locale() {
    return this.currentLocale;
  },
  get intl() {
    return this.intlInstance;
  },
};
